import Axios from 'axios'
import { getCookie, setCookie } from './cookie'
import Api from './api.js'
import { setTimeout } from 'core-js';
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';
import i18n from "@/utils/i18n";
var errFlag = true;//解决循环弹出错误提示标识
var noUseFlag = true;//解决循环弹出"服务不可以，联系管理员"标识
import store from "../../store"

import {getConfig} from "../../config/js/tool"
let openWindow = (href, type) => {
  var newWin = window.open();
  newWin.location = href
};
let pendingRequestArr = [];//保存pending状态的网络请求 
let isLoginType = false;
function isEmptyOrEmptyObject(v) {
  // 1. 先处理所有“空值”
  if (v == null) return true;            // null / undefined
  if (typeof v !== 'object') return !v;  // 原始类型：'', 0, false, NaN 都算空

  // 2. 再处理对象：数组、日期、正则等都不算“空对象”
  return Object.keys(v).length === 0;
}
export function request(config) {
	if(config.data?.isLoginType){
		isLoginType = true
	}else{
		isLoginType = false
	}
	const router = useRouter();
	let cancelToken = Axios.CancelToken;
  	let authorization = ''
	if (getCookie("userInfoB2B")) {
		if (JSON.parse(getCookie("userInfoB2B"))) {
			authorization = JSON.parse(getCookie("userInfoB2B")).tokenType + " " + JSON.parse(getCookie("userInfoB2B")).accessToken
		}
	}
	setCookie('authorizationB2B',authorization)
	//取消请求fn
	let cancelPendingFn = (res) => {
		// pendingRequestArr.forEach((item,index)=>{
		// 	if(item.url==res.url){
		// 		item.cancelFn();
		// 		pendingRequestArr.splice(index,1);//从数组移除当前请求记录
		// 	}
		// })
	}
	//创建Axios实例，添加通用配置
	const instance = Axios.create({
		method: config.method ? config.method : "post",
		timeout: 30000,
		headers: config.header ? config.header : {
			// 'content-type': 'application/json',
			'Authorization': authorization,
			'withCredentials': true
		},
	})


	//实例请求拦截器
	instance.interceptors.request.use((res) => {
		return new Promise(resolve=>{
			setTimeout(()=>{
				cancelPendingFn(res);
				if(!res.url){return}
				if(res.url && res.url.substr(0,4).toLowerCase() == "http" ){
					res.url;
				}else{
					res.url = process.env.VUE_APP_BASE_API+process.env.VUE_APP_PUBLIC_NAME+Api[res.url]
				}
				if(!res.data){
					res.data = {}
				}
				res.data.timestamp = Date.now()
				res.data.language = i18n.global.locale.value
				res.cancelToken = new cancelToken((cancelFn) => {
					pendingRequestArr.push({ "url": res.url, "cancelFn": cancelFn })
				})
				resolve(res)
			},300)
		})
	}, (err) => {
		return Promise.reject(err);
	})

	//实例响应拦截器
	instance.interceptors.response.use((res) => {
		if(res.data.code && res.data.code!='000'){
			if (noUseFlag && !res.config.cancelMsg) {
				noUseFlag = false;
				ElMessage.error({
					message: res.data.msg,
					duration: '2500',
					onClose: function () {
						noUseFlag = true;
					}
				});
			}
		}
		cancelPendingFn(res.config);
		return res;
	}, (error) => {
		console.log(error);

		let err = error.response;
		if (errFlag) {
			if(err){
        
				if (err.status == "401") {
					setCookie('userInfoB2B', '');
					setCookie('loginName', '');
					store.commit('setUserInfoB2B', '');
					if(isLoginType){
						//router.push('/login')
						var localObj = window.location;
						// openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href)
						if(process.env.NODE_ENV=="test"){
						//openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href);
						window.location=localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href
						}else{
						//openWindow("https://nfstzx.com/login?redirect_url="+localObj.href);
						
						let redirectUrl = !isEmptyOrEmptyObject(getConfig('redirectUrl'))?getConfig('redirectUrl'):localObj.protocol + "//" + localObj.host
						window.location=redirectUrl+"/login?redirect_url="+localObj.href
						}

					}
				} else if (err.status == "500") {
					// errFlag = false;
					ElMessage({
						message: err.data.msg,
						onClose: function () {
							errFlag = true;
						}
					});
				}
			}else{
				ElMessage({
					message: err.message,
					onClose: function () {
						errFlag = true;
					}
				});
			}
			
		}



		// var isErrInfo = err.response.data.error_description.indexOf('Access token expired');//权限是否过期
		//    var isErrInfo1 = err.response.data.error_description.indexOf('An Authentication object was not found in the SecurityContext');//没有token串
		//       if(errFlag) {
		//         if( isErrInfo>=0 ) {
		//           setCookie('userInfoB2B','');
		//           setCookie('loginName','');
		//           localStorage.setItem("menuBuyType","");
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else if( isErrInfo1>=0 ) {
		//           errFlag = false;
		//           vm.$router.push('/'); 
		//         } else {
		//           ElMessage('服务暂时不可用，请联系管理员');
		//         }
		//         return false;
		//       }
		//return Promise.reject(err);
		return Promise.reject(err).catch((error) => {
			if (error.data == "server exception: code = 404 msg = Not Found") {//说明没开通此服务
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: '服务暂时不可用，请联系管理员',
						duration: '4000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '500') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			if (error.status == '403') {
				if (noUseFlag) {
					noUseFlag = false;
					ElMessage.error({
						message: error.data.msg ? error.data.msg : '服务端异常',
						duration: '3000',
						onClose: function () {
							noUseFlag = true;
						}
					});
				}
			}
			return Promise.reject(err);//为了在具体页面请求中 catch中获取错误信息
		});
		
	})

	//返回axios的实例，也是一个promise
	return instance(config)
	
}

/*
具体页面中使用方式
request({
	url:"xxxx",
	method:"post",
	data:{},
}).then((res)=>{

}).catch((err)=>{

})

*/
